import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sparkles } from "lucide-react";
import { MODULES } from "@/lib/modules";
import { Button } from "@/components/ui/button";

export default function ModuleStub() {
  const { slug } = useParams();
  const mod = MODULES.find((m) => m.slug === slug);

  if (!mod) {
    return (
      <div className="mx-auto max-w-2xl py-20 text-center">
        <h1 className="font-display text-3xl">Module not found</h1>
        <Link to="/app" className="mt-4 inline-block text-white/60 hover:text-white">← Back to dashboard</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl">
      <Link to="/app" className="inline-flex items-center gap-1 text-xs text-white/55 hover:text-white" data-testid="module-back">
        <ArrowLeft className="h-3 w-3" /> Back to home
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="mt-6"
      >
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500/30 via-violet-500/20 to-fuchsia-500/30 border border-white/10">
            <mod.icon className="h-7 w-7 text-fuchsia-400" />
          </div>
          <div>
            <div className="text-eyebrow text-fuchsia-400">{mod.phase}</div>
            <h1 className="font-display mt-1 text-4xl font-light tracking-tight sm:text-5xl">{mod.name}</h1>
          </div>
        </div>
        <p className="mt-5 max-w-2xl text-white/55">{mod.description}</p>

        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1, duration: 0.6 }}
          className="glass-heavy relative mt-10 overflow-hidden rounded-3xl p-10"
          data-testid={`module-stub-${slug}`}
        >
          <div className="absolute inset-x-0 top-0 h-0.5 brand-bg" />
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
            <Sparkles className="h-3.5 w-3.5 text-fuchsia-400" /> Coming in {mod.phase}
          </div>
          <h2 className="font-display text-3xl font-light tracking-tight">We're shipping this soon.</h2>
          <p className="mt-2 max-w-xl text-white/55">
            {mod.name} is part of the staged Symplee rollout. Your subscription
            covers every module — including this one — at launch.
          </p>
          <div className="mt-6 flex flex-col gap-2 sm:flex-row">
            <Link to="/app">
              <Button className="rounded-full bg-white text-black hover:bg-zinc-200">
                Back to dashboard
              </Button>
            </Link>
            <Link to="/app/settings?tab=billing">
              <Button variant="outline" className="rounded-full border-white/15 bg-white/5 text-white hover:bg-white/10">
                Manage billing
              </Button>
            </Link>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
